export default {
  placeholders: {
    first_name: 'Primeiro nome',
    last_name: 'Apelido',
    email: 'Email',
    mobile_number: 'Número de telemóvel',
  },
  labels: {
    exclusive_offers_via_email: 'Gostaria de receber ofertas exclusivas e novidades por email.',
  },
  buttons: {
    sign_up: 'Registar',
  },
};
